import React from 'react';

export default function DisclaimerModal({ onClose, disclaimerIndex }) {
  const disclaimers = {
    1: `This List Price configuration program is for informational purposes only. Price on this sales
        quote is an estimate and is subject to being increased. Payment assumes the MSRP of your selected
        equipment and accessories, the length of term you have selected and any applicable special A.P.R.
        program. Not Included: *Taxes, shipping; handling, surcharges, assembly charges, destination,
        freight and/or delivery charges.  Not all models are available to order. Contact your dealer for available inventory stock or future availability.`,

    2: `This List Price configuration program is for informational purposes only. Price on this sales
        quote is an estimate and is subject to being increased. Payment assumes the MSRP of your selected
        equipment and accessories, the length of term you have selected and any applicable special A.P.R.
        program. Not Included: *Taxes, shipping; handling, surcharges, assembly charges, destination,
        freight and/or delivery charges.  Not all models are available to order. Contact your dealer for available inventory stock or future availability.`,

    3: `This List Price configuration program is for informational purposes only. Price on this sales
        quote is an estimate and is subject to being increased. Payment assumes the MSRP of your selected
        equipment and accessories, the length of term you have selected and any applicable special A.P.R.
        program. Not Included: *Taxes, shipping; handling, surcharges, assembly charges, destination,
        freight and/or delivery charges.  Not all models are available to order. Contact your dealer for available inventory stock or future availability.`,

    4: `This List Price configuration program is for informational purposes only. Price on this sales
        quote is an estimate and is subject to being increased. Payment assumes the MSRP of your selected
        equipment and accessories, the length of term you have selected and any applicable special A.P.R.
        program. Not Included: *Taxes, shipping; handling, surcharges, assembly charges, destination,
        freight and/or delivery charges.  Not all models are available to order. Contact your dealer for available inventory stock or future availability.`,

    5: `This List Price configuration program is for informational purposes only. Price on this sales
        quote is an estimate and is subject to being increased. Payment assumes the MSRP of your selected
        equipment and accessories, the length of term you have selected and any applicable special A.P.R.
        program. Not Included: *Taxes, shipping; handling, surcharges, assembly charges, destination,
        freight and/or delivery charges.  Not all models are available to order. Contact your dealer for available inventory stock or future availability.`,

    6: `Kubota's reputation for quality likely made your equipment purchase decision an easy one. Now let
        us take your confidence in Kubota to the next level with Kubota-Endorsed Property Damage Insurance.
        After all, who knows the value of your Kubota better than the company that engineered it with the
        quality you've come to trust? Protect your Kubota through Kubota Tractor Acceptance Corporation
        (KTAC) and ensure your peace of mind.`,

    7: `The Orange Protection Program is a Kubota-backed, no deductible extended warranty solution.
        The program is designed to keep you productive in the unfortunate event of a failure in material
        or workmanship after the expiration of the Kubota Limited Warranty by one or two years.`,
  };

  const disclaimerText = disclaimers[disclaimerIndex] || '';

  return (
    <>
      <div className="modal-header">
        <h2 className="modal-title">Disclaimer</h2>
      </div>
      <div className="modal-body saveBuildModalBody">
        <div className="disclaimer-content">
          <p>{disclaimerText}</p>
        </div>
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <button className="orange-button button" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </>
  );
}